$(document).ready(function()
{
    class CooldownHandler {

        cooldownCallback = null;
        shortCooldownDelay = 500;
        longCooldownDelay = 600;
        useShortDelayAfter = 500;
        lastCooldownSetAt = 0;

        checkForCooldown (callback) {
            const doSetTimeOut = !this.cooldownCallback;
            this.cooldownCallback = callback;
            if(doSetTimeOut){
                const useShortDelay = Date.now() - this.lastCooldownSetAt > this.useShortDelayAfter;

                setTimeout(() => {
                    this.lastCooldownSetAt = Date.now();
                    const cooldownCallback = this.cooldownCallback;
                    this.cooldownCallback = null;
                    if(cooldownCallback){
                        cooldownCallback()
                    }
                }, useShortDelay ? this.shortCooldownDelay : this.longCooldownDelay);
            }
        }
    }

    const sliderElCooldownHandler = new CooldownHandler();
    const sliderEl2CooldownHandler = new CooldownHandler();

    /*
        basic prmeise is that when any dropdown filter is clicked 
            we close all cards
            then for each card, go through each currently filter and see it matches them all
            open it if so.
        it's flexible in that it works with anything from 1 to N filter groups at once.
    */


    if ($('.filters-box').length)
    {
        $( ".stay-on-page-dropdown-menu a" ).click(function(e) 
        {
            e.preventDefault();
            let filterValue = $(this).data("filter-value");
            let text = $(this).text();

            let key = $(this).parent().data('card-toggle');


            $(this).parent().attr('data-current-value', filterValue);

            if (filterValue == '')
            {
               let default_text = $(this).parent().siblings('.dropdown-toggle').data("default-text");
                $(this).parent().siblings('.dropdown-toggle').html(default_text);
            }
            else
            {
                $(this).parent().siblings('.dropdown-toggle').html(text);
            }
            applyDropdownFilters();
        });

    }

    if ($('#rangePrice').length)
    {

        const sliderEl = document.querySelector("#rangePrice")
        const sliderValue = document.querySelector("#rangePriceValue")

        sliderEl.addEventListener("input", (event) => 
        {
            const tempSliderValue = event.target.value;
            sliderValue.textContent = parseInt(tempSliderValue).toLocaleString("en-US", {style:"currency", currency:"GBP", minimumFractionDigits: 0, maximumFractionDigits: 0});

            const progress = (tempSliderValue / sliderEl.max) * 100;

            sliderEl.style.background = 'linear-gradient(to right, #f50 ${progress}%, #ccc ${progress}%)';

            sliderElCooldownHandler.checkForCooldown(() => {
                applyDropdownFilters();
            })
        })
    }

    if ($('#rangeArea').length)
    {

        const sliderEl2 = document.querySelector("#rangeArea")
        const sliderValue2 = document.querySelector("#rangeAreaValue")

        sliderEl2.addEventListener("input", (event) => 
        {
            const tempSliderValue2 = event.target.value;
            sliderValue2.textContent = parseInt(tempSliderValue2).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 0});

            const progress2 = (tempSliderValue2 / sliderEl2.max) * 100;

            sliderEl2.style.background = 'linear-gradient(to right, #f50 ${progress2}%, #ccc ${progress2}%)';

            sliderEl2CooldownHandler.checkForCooldown(() => {

                applyDropdownFilters();
            })
        })
    }
    function applyDropdownFilters()
    {
        let active_ids = 0;
        

        $('.listings-group .col').each(function(i, obj)
        {
            $(this).fadeOut(300);
        });

        $('.listings-group .col').each(function(i, obj)
        {
            hideItem = 0;
            let current_col = $(this);
            $('.stay-on-page-dropdown-menu').each(function()
            {

                let needle = $(this).attr('data-current-value');
                let haystack = $(this).attr('data-card-toggle');
                if(needle) 
                {

                    if (current_col.data(haystack).includes(needle))
                    {
                        // do nothing
                    }
                    else
                    {
                        hideItem++;
                    }
                }
            });

            if ($('#rangePrice').length)
            {
                let maxPrice = $('#rangePrice').val();
                let current_col_price = current_col.data("price");

                //console.log(maxPrice, current_col_price);

                if (current_col_price > maxPrice)
                {
                    hideItem++;
                }
            }

            if ($('#rangeAreaValue').length)
            {
                let maxArea = $('#rangeArea').val();
                let current_col_area = current_col.data("area");

                if (current_col_area > maxArea)
                {
                    hideItem++;
                }
            }

            if(hideItem == 0)
            {
                active_ids++
                current_col.fadeIn(300); 
            }

        });


        //console.log(needles);


        $('#page-counter-results').text(active_ids + " listing" + ( (active_ids != 1) ? "s" : ''  ));

        if (active_ids > 0)
        {
            $("#no-results").removeClass("active");                
        }
        else
        {
            $("#no-results").addClass("active");   
        }

    }

});